export default __webpack_public_path__ + "static/media/wu.dfad04e8.png";